'use strict';

import dispatcher from '../dispatcher';
// import store from './map.store';

import {isIE} from '../utils';

const ie = isIE();


const mapLang = document.documentElement.getAttribute('lang') || 'en',
      mapVersion = '3';

const styles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];


let initialized = false;
let load = false;
let waitArray = [];



function _initialize(mapKey) {
  if (!load) {
    let script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?v=${mapVersion}&key=${mapKey}&language=${mapLang}&callback=initMaps`;

    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    document.body.appendChild(script);

    window.initMaps = function () {
      for (let i = 0; waitArray.length > i; i++) {
        waitArray[i]();
      }
      initialized = true;
    };
  }

  load = true;
}




class GoogleMap extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.build = e => this._build(e);
  }
  connectedCallback() {
    this._container = this.querySelector('.view-map-container');
    this._lat = +this.dataset.lat || 0;
    this._lng = +this.dataset.lng || 0;
    this._zoom = +this.dataset.zoom || 10;
    this._markers = [];

    if (!initialized) {
      if (!load) {
        _initialize(this.dataset.key);
      }
      waitArray.push(this.build);
    } else {
      this._build();
    }
  }
  disconnectedCallback() {
    for (let i = 0; waitArray.length > i; i++) {
      if (waitArray[i] === this.build) {
       waitArray.splice(i, 1);
      }
    }
  }

  _build() {
    this._config = {
      zoom: this._zoom,
      // mapTypeControlOptions: {
      //   style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      //   position: google.maps.ControlPosition.TOP_RIGHT
      // },
      mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_RIGHT
        },
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      scrollwheel: false,
      streetViewControl: false,
      center: new google.maps.LatLng(this._lat, this._lng),
      styles: styles
    };

    this._map = new google.maps.Map(this._container, this._config);

    let markers = this.querySelectorAll('.view-map-marker');

    for (let i = 0; markers.length > i; i++) {
      this._addMarker({
        lat: markers[i].getAttribute('data-lat') || 0,
        lng: markers[i].getAttribute('data-lng') || 0,
        color: markers[i].getAttribute('data-color') || false,
        title: markers[i].getAttribute('data-title') || '',
      });
    }


    dispatcher.dispatch({
      type: 'map-initialized',
      map: this
    });
  }
  _addMarker(marker) {
    let icon = {
      url: require('../../media/images/marker' + (marker.color ? '_' + marker.color : '') + '.' + (ie ? 'png' : 'svg')),
      size: new google.maps.Size(39, 33),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(20, 38)
    };

    let latLng = new google.maps.LatLng(marker.lat, marker.lng);

    let newMarker = new google.maps.Marker({
      position: latLng,
      map: this._map,
      icon: icon,
      title: marker.title
    });

    this._markers.push(newMarker);
  }
}


window.customElements.define('google-map', GoogleMap);